// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__3L2bW","content":"RecentSearches_content__30kyx"};